var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('overlay-scrollbars',{ref:"os",staticClass:"page page-neobank"},[_c('Table',{attrs:{"options":_vm.getTableData},on:{"more-modal":_vm.openMoreModal,"rating-modal":_vm.openRatingModal,"scroll-top":_vm.toElTop}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }